<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        :mode="mode"
        v-slot="{ errors }"
        class="flex flex-col"
    >
        <textarea
            class="bg-transparent border-b-2 border-blue-lightest pb-3 font-secondary fomt-semibold text-gray-600 placeholder-gray-600"
            :placeholder="placeholder"
            :value="value"
            @input="$emit('input', $event.target.value)"
            cols="cols"
            rows="rows"
            :required="required"
        >
        </textarea>
        <span
            class="font-secondary text-xs text-red-500"
            :style="{ minHeight: '20px' }"
            >{{ errors[0] }}</span
        >
    </ValidationProvider>
</template>

<script>
export default {
    name: "form-input",

    props: {
        name: {
            type: String,
            required: true
        },

        value: {
            type: String,
            required: true
        },

        placeholder: {
            type: String
        },

        required: {
            type: Boolean,
            default: false
        },

        cols: {
            type: Number,
            default: 30
        },

        rows: {
            type: Number,
            default: 10
        },

        rules: {
            type: String,
            default: ""
        },

        mode: {
            type: String,
            default: "lazy"
        }
    }
};
</script>
